import { ConfigProps } from 'types/config';

export const BASE_PATH = '';

export const DASHBOARD_PATH = '/my-applications';

const config: ConfigProps = {
    fontFamily: `'Montserrat', sans-serif`
};

export default config;
